export default "__VITE_ASSET__CX_17vw3__"